var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgBulb(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("defs", null, React.createElement("path", {
    id: "bulb_svg__a",
    d: "M0 0h24v24H0z"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 4)"
  }, React.createElement("mask", {
    id: "bulb_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#bulb_svg__a"
  })), React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M15.5 19.5V21c0 .778-.597 1.42-1.356 1.493L14 22.5h-4c-.778 0-1.42-.597-1.493-1.356L8.5 21v-1.5h7zm-1 1h-5v.5c0 .213.137.397.326.468l.085.024.089.008h4c.243 0 .45-.179.492-.41L14.5 21v-.5zM12 1.5c4.141 0 7.5 3.359 7.5 7.5a7.48 7.48 0 01-2.767 5.812l-.233.181V17c0 .729-.525 1.34-1.216 1.473l-.14.02L15 18.5H9c-.778 0-1.42-.597-1.493-1.356L7.5 17v-2.006l-.013-.01A7.486 7.486 0 014.52 9.569l-.016-.283L4.5 9c0-4.141 3.359-7.5 7.5-7.5zm0 1A6.501 6.501 0 005.5 9c0 2.06.967 3.954 2.573 5.175l.213.155.214.15V17c0 .243.179.45.41.492L9 17.5h6c.243 0 .45-.179.492-.41L15.5 17v-2.52l.214-.15A6.488 6.488 0 0018.5 9c0-3.589-2.911-6.5-6.5-6.5z",
    mask: "url(#bulb_svg__b)"
  })));
}

export default SvgBulb;